// Der Übersetzen-Knopf im Bearbeiten-Formular einer Vorlage
// (app/views/templates/edit.html.erb, nur für Pro gerendert): schlägt aus den
// deutschen Texten der Vorlage -- sie stehen als JSON am Knopf -- die
// englische Fassung vor und trägt sie in die drei Felder. Gespeichert wird
// erst mit „Speichern"; was schon in den Feldern stand, wird nur nach
// Rückfrage ersetzt.

import { t } from '../i18n'
import { requestTemplateTranslation, translateErrorMessage, type TemplateTexts } from '../lib/translateTemplate'

const FIELDS = {
  title: '#template_title_en',
  description: '#template_description_en',
  tags: '#template_tags_en_text',
} as const

type Field = HTMLInputElement | HTMLTextAreaElement

export function startTemplateTranslate(root: ParentNode = document): void {
  const button = root.querySelector<HTMLButtonElement>('[data-template-translate]')
  if (!button) return

  const form = button.closest('form')
  const status = root.querySelector<HTMLElement>('[data-template-translate-status]')
  const field = (selector: string) => form?.querySelector<Field>(selector) ?? null

  button.addEventListener('click', () => {
    const source = JSON.parse(button.dataset.templateTranslate ?? '{}') as TemplateTexts
    const filled = Object.values(FIELDS).some((selector) => (field(selector)?.value ?? '').trim() !== '')
    if (filled && !window.confirm(t('publish.translateOverwrite'))) return

    button.disabled = true
    if (status) status.textContent = t('publish.translating')

    void requestTemplateTranslation('de', 'en', source)
      .then((result) => {
        const title = field(FIELDS.title)
        const description = field(FIELDS.description)
        const tags = field(FIELDS.tags)
        if (title) title.value = result.title
        if (description) description.value = result.description
        if (tags) tags.value = result.tags.join(', ')
        if (status) status.textContent = t('publish.translated')
      })
      .catch((caught: unknown) => {
        if (status) status.textContent = translateErrorMessage(caught)
      })
      .finally(() => {
        button.disabled = false
      })
  })
}
